import request from '@/utils/server'

//  请求列表
export function getKeepSampleList(query) {
  return request({
    url: '/getKeepSampleList',
    method: 'get',
    params: query
  })
}